/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Multi_Select_HintInputs */

const en_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click to select. Ctrl/Cmd-click to toggle. Shift-click to select a range.`)
};

const fr_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez pour sélectionner. Ctrl/Cmd+clic pour basculer. Maj+clic pour sélectionner une plage.`)
};

const de_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klicken zum Auswählen. Strg/Cmd+Klick zum Umschalten. Umschalt+Klick für Bereichsauswahl.`)
};

const it_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca per selezionare. Ctrl/Cmd+clic per attivare/disattivare. Shift+clic per selezionare un intervallo.`)
};

const ru_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кликните для выбора. Ctrl/Cmd+клик — переключить. Shift+клик — выбрать диапазон.`)
};

const es_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga clic para seleccionar. Ctrl/Cmd+clic para alternar. Mayús+clic para seleccionar un rango.`)
};

const zh_cn2_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`单击以选择。Ctrl/Cmd+单击以切换。Shift+单击以选择范围。`)
};

const ja_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリックで選択。Ctrl/Cmd+クリックで切り替え。Shift+クリックで範囲を選択。`)
};

const hi_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयन करने के लिए क्लिक करें। टॉगल करने के लिए Ctrl/Cmd+क्लिक करें। श्रेणी चुनने के लिए Shift+क्लिक करें।`)
};

const pt_pt2_multi_select_hint = /** @type {(inputs: Multi_Select_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique para selecionar. Ctrl/Cmd+clique para alternar. Shift+clique para selecionar um intervalo.`)
};

/**
* | output |
* | --- |
* | "Click to select. Ctrl/Cmd-click to toggle. Shift-click to select a range." |
*
* @param {Multi_Select_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const multi_select_hint = /** @type {((inputs?: Multi_Select_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Multi_Select_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_multi_select_hint(inputs)
	if (locale === "de") return de_multi_select_hint(inputs)
	if (locale === "it") return it_multi_select_hint(inputs)
	if (locale === "ru") return ru_multi_select_hint(inputs)
	if (locale === "es") return es_multi_select_hint(inputs)
	if (locale === "zh-CN") return zh_cn2_multi_select_hint(inputs)
	if (locale === "ja") return ja_multi_select_hint(inputs)
	if (locale === "hi") return hi_multi_select_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_multi_select_hint(inputs)
	return en_multi_select_hint(inputs)
});